module.exports = __webpack_public_path__ + "img/mood_cold.2c08d226.png";